import React, { Fragment } from "react";

import { Form, Input } from "antd";
import Notification from "../../Notification";

const { Item } = Form;

const InputEmail = (props) => {
  const {
    id,
    type,
    placeholder,
    name,
    label,
    required,
    value,
    className,
    error = "",
    onChangeHandler,
    formatId,
    disabled = false,
    verified = false,
  } = props;

  return (
    <div>
      <Item
        key={id}
        name={name}
        label={label}
        size="true"
        rules={[
          {
            required: required,
            type: type,
          },
        ]}
        className={`${className} ${!label ? "outline-item-element" : ""}`}
      >
        <Input
          className="form-email-element"
          placeholder={placeholder}
          size="small"
          onChange={(e) => onChangeHandler(e.target.value, id)}
          value={value}
          id={formatId(label)}
          disabled={disabled}
          autoComplete={"off"}
          suffix={
            verified ? (
              <span className="field-verified-badge">
                <img src="/assets/icons/success.svg" alt="verified" />
              </span>
            ) : null
          }
        />
      </Item>

      {error && (
        <Fragment>
          <Notification type="required" message={error} image={false} />
        </Fragment>
      )}
    </div>
  );
};

export default InputEmail;
